import PropTypes from 'prop-types';

const FormRow = ({
  type,
  name,
  labelText,
  handleChange,
  placeholder = '',
  isRequired = false,
  defaultValue = '',
}) => {
  return (
    <div className='form-row'>
      <label htmlFor={name} className='form-label'>
        {labelText || name}
      </label>
      <input
        type={type}
        id={name}
        name={name}
        className='form-input'
        onChange={handleChange}
        placeholder={placeholder}
        defaultValue={defaultValue}
        required={isRequired}
        min={type === 'number' ? 0 : undefined}
        max={type === 'number' ? 10000 : undefined}
      />
    </div>
  );
};

FormRow.propTypes = {
  type: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  labelText: PropTypes.string,
  placeholder: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  isRequired: PropTypes.bool,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  min: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  max: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default FormRow;
